module.exports = __webpack_public_path__ + "img/overdue-filter.17420537.svg";